import React, { Component } from "react";
import Close from "../../../../../../Icons/Close";
import { styles } from "../../../../../../ReactConst";
import { StyleRoot } from "radium";
import { withTranslation } from 'react-i18next';
class ModaleConfirmationDelete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
  }
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  closeModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.handleCloseDelete();
    }, 400);
  };

  render() {
    const { t } = this.props;
    return (
      <StyleRoot>
        <div
          className="modal modal-skin show actif"
          id="modalDelete"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close
                    className="img-fluid"
                    alt=""
                    onClick={this.closeModal}
                  />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title">{t('modal_enfant.delete_ordonnance')}</h5>
                  </section>
                  <section className="d-flex justify-content-center">
                    <h5>
                      {t('modal_enfant.delete_ordonnance_confirm')}
                    </h5>
                  </section>
                  <p className="bottom-space"></p>
                  <section>
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn-gradient btn-confirm"
                        onClick={this.props.confirmDeleteTreatement}
                      >
                        <img
                          src="img/icon-check-white.svg"
                          class="img-fluid"
                          alt=""
                        />{" "}
                        {t('common.confirm')}
                      </button>
                    </div>
                  </section>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}

export default withTranslation()(ModaleConfirmationDelete);
